import { MenuItem, Select as VaporSelect } from '@vapor/material'
import { Select as MUISelect } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReservationF } from '../types/reservation-detail.types'
import { ReservedResourceOption, NotSelectedOptionType, useReservedResourceOptions } from '../../../../hooks/reserved-resources/reserved-resource-options'

const HicSelect = VaporSelect as unknown as typeof MUISelect

export const NOT_SELECTED = 'NOT_SELECTED'

export type ReservedResourceFilterProps = {
  reservation: ReservationF
  defaultReservedResourceId?: string
  onSelectedReservedResourceChange?: (reservedResourceId: string | null) => void
}

const notSelectedOption: NotSelectedOptionType = {
  id: NOT_SELECTED,
  notSelected: true,
}

export default function ReservedResourceFilter({ reservation, defaultReservedResourceId, onSelectedReservedResourceChange }: ReservedResourceFilterProps) {
  const { t } = useTranslation()
  const [value, setValue] = useState<string>(
    defaultReservedResourceId ? reservation.reservedResources?.find((rr) => rr.id === defaultReservedResourceId)?.id || notSelectedOption.id : notSelectedOption.id,
  )
  useEffect(() => {
    if (onSelectedReservedResourceChange) {
      const reservedResourceId: string | null = value === notSelectedOption.id ? null : value
      onSelectedReservedResourceChange(reservedResourceId)
    }
  }, [onSelectedReservedResourceChange, value])

  const options: ReservedResourceOption[] = useReservedResourceOptions(reservation)

  return (
    <HicSelect<string> //
      fullWidth
      value={value}
      onChange={(event) => setValue(event.target.value)}
    >
      {options.map((option) => {
        return (
          <MenuItem key={option.id} value={option.id}>
            {'index' in option
              ? `${option.index} ${option.assignedResourceType || option.resourceType || ''} (${option.resourceCode || '-'})`
              : t('pms.booking.reservation.reserved_resource_not_selected')}
          </MenuItem>
        )
      })}
    </HicSelect>
  )
}
